import React from 'react';
import { Nav, Navbar } from 'react-bootstrap';
import { Route, Switch } from "react-router-dom";
import { connect } from "react-redux";

import SideNavigationLabel from "../side/SideNavigationLabel";
import SideNavigationToggle from "../side/SideNavigationToggle";
import SideNavigationNavLink from "../side/SideNavigationNavLink";


import Common from "./Common";

import Languages from "./Languages";
import HomeLatestNews from './HomeLatestNews';
import HomeExternalLinks from './HomeExternalLinks';
import HomeSelections from './HomeSelections';
import LoginPageLinks from './LoginPageLinks';
import LoginPageLatestNews from './LoginPageLatestNews';
import LoginPageSlides from './LoginPageSlides';
import LoginPageRegistration from './LoginPageRegistration';
import PerformanceMonitoring from "./PerformanceMonitoring";
import LandNotificationOneAlerts from "./LandNotificationOneAlerts";
import MultiTenantList from "./MultiTenantList"
import HelloWorld from "./HelloWorld";
import UserLockout from "./UserLockout";
import UserLockout2 from "./UserLockout2";
import UserPurgeSchedule from "./UserPurgeSchedule";
import UserPurgeNow from "./UserPurgeNow";
import UserAccess from "./UserAccess";
import UserReport from "./UserReport";
import UserList from "./UserList";
import AlertSettings from "./AlertSettings";
import AlertList from "./AlertList";
import EmailList from "./EmailList";
import PhoneList from "./PhoneList";
import UserEntry from "./UserEntry";
import UserPassword from "./UserPassword";
import AuditLogPurgeSchedule from "./AuditLogPurgeSchedule";
import AlertEntry from './AlertEntry';
import CommonTop from "../../components/top/CommonTop";

import { HomeSelectionsControlPanelKey, HomeLatestNewsControlPanelKey, HomeExternalLinksControlPanelKey, CommonControlPanelKey, LanguagesControlPanelKey, PerformanceMonitoringControlPanelKey, MultiTenantListControlPanelKey,
	UserAccessControlPanelKey, UserPurgeScheduleControlPanelKey, UserPurgeNowControlPanelKey, UserLockoutControlPanelKey, UserLockout2ControlPanelKey, UserListControlPanelKey, 
	AlertSettingsControlPanelKey, AlertListControlPanelKey, EmailListControlPanelKey, PhoneListControlPanelKey,
	LoginPageLatestNewsControlPanelKey, LoginPageLinksControlPanelKey, LoginPageSlidesControlPanelKey, LoginPageRegistrationControlPanelKey,
	AuditLogPurgeScheduleControlPanelKey, AuditLogReportControlPanelKey,
	LandNotificationOneAlertsControlPanelKey, HelloWorldControlPanelKey} from "../../redux/actions/controlPanelActions";

import { buildingIcon, buildingActiveIcon, auditLogPurgeIcon, auditLogPurgeActiveIcon, loginIcon, loginActiveIcon, languageIcon, languageActiveIcon, 
		bellIcon, bellActiveIcon, bellIconBlack, mobileIcon, mobileActiveIcon, envelopeIcon, envelopeActiveIcon,
	  	 userIconBlack, fileIcon, fileActiveIcon, fileCodeIcon, homeIcon, homeActiveIcon, commonIcon, commonActiveIcon,
		 userPurgeIcon, userPurgeActiveIcon, userClockIcon, userClockActiveIcon, userLockIcon, userLockActiveIcon, usersIcon, usersActiveIcon, doorOpenIcon, doorOpenActiveIcon,
		 stethoscopeIcon, stethoscopeActiveIcon, cogIconBlack, cogIcon, cogActiveIcon, arrowRightIcon, arrowRightActiveIcon, smileIcon, smileActiveIcon } from "../../img/font_awesome/font_awesome"
import AlertView from './AlertView';


const mapStateToProps = state => {
	return {
		selectedControlPanelType: state.controlPanelTypeReducer.selectedControlPanelType,
		role: state.currentUserReducer.role  
	};
}

class ControlPanel extends React.Component {

	render() {
		let webPagesProps = {
			image: fileCodeIcon,
			name: "Web Pages:"
		}

		let commonProps = {
			id: "commonControlPanelNavLink",
			link: "/controlPanel/Common",
			selected: this.props.selectedControlPanelType === CommonControlPanelKey,
			image: this.props.selectedControlPanelType === CommonControlPanelKey ? commonActiveIcon : commonIcon,
			name: "Common"
		}

		let languagesProps = {
			id: "languagesControlPanelNavLink",
			link: "/controlPanel/Languages",
			selected: this.props.selectedControlPanelType === LanguagesControlPanelKey,
			image: this.props.selectedControlPanelType === LanguagesControlPanelKey ? languageActiveIcon : languageIcon,
			name: "Languages"
		}

		let homeLatestNewsProps = {
			id: "homeLatestNewsControlPanelNavLink",
			link: "/controlPanel/HomeLatestNews",
			selected: this.props.selectedControlPanelType === HomeLatestNewsControlPanelKey,
			image: this.props.selectedControlPanelType === HomeLatestNewsControlPanelKey ? homeActiveIcon : homeIcon,
			name: "Home - More News"
		}

		let homeMoreLinksProps = {
			id: "homeExternalLinksControlPanelNavLink",
			link: "/controlPanel/HomeExternalLinks",
			selected: this.props.selectedControlPanelType === HomeExternalLinksControlPanelKey,
			image: this.props.selectedControlPanelType === HomeExternalLinksControlPanelKey ? homeActiveIcon : homeIcon,
			name: "Home - More Links"
		}

		let homeSelectionsProps = {
			id: "homeSelectionsControlPanelNavLink",
			link: "/controlPanel/HomeSelections",
			selected: this.props.selectedControlPanelType === HomeSelectionsControlPanelKey,
			image: this.props.selectedControlPanelType === HomeSelectionsControlPanelKey ? homeActiveIcon : homeIcon,
			name: "Home - Selections"
		}

		let loginPageLinksProps = {
			id: "loginPageLinksControlPanelNavLink",
			link: "/controlPanel/LoginPageLinks",
			selected: this.props.selectedControlPanelType === LoginPageLinksControlPanelKey,
			image: this.props.selectedControlPanelType === LoginPageLinksControlPanelKey ? loginActiveIcon : loginIcon,
			name: "Login - Links"
		}

		let loginPageLatestNewsProps = {
			id: "loginPageLatestNewsControlPanelNavLink",
			link: "/controlPanel/LoginPageLatestNews",
			selected: this.props.selectedControlPanelType === LoginPageLatestNewsControlPanelKey,
			image: this.props.selectedControlPanelType === LoginPageLatestNewsControlPanelKey ? loginActiveIcon : loginIcon,
			name: "Login - Latest News"
		}

		let loginPageSlidesProps = {
			id: "loginPageSlidesControlPanelNavLink",
			link: "/controlPanel/LoginPageSlides",
			selected: this.props.selectedControlPanelType === LoginPageSlidesControlPanelKey,
			image: this.props.selectedControlPanelType === LoginPageSlidesControlPanelKey ? loginActiveIcon : loginIcon,
			name: "Login - Slides"
		}

		let loginPageRegistrationProps = {
			id: "loginRegistrationControlPanelNavLink",
			link: "/controlPanel/LoginPageRegistration",
			selected: this.props.selectedControlPanelType === LoginPageRegistrationControlPanelKey,
			image: this.props.selectedControlPanelType === LoginPageRegistrationControlPanelKey ? loginActiveIcon : loginIcon,
			name: "Login - Registration"
		}
		
		let technicalProps = {
			image: cogIconBlack,
			name: "Technical:"
		}

		let performanceMonitoringProps = {
			id: "performanceMonitoringControlPanelNavLink",
			link: "/controlPanel/PerformanceMonitoring",
			selected: this.props.selectedControlPanelType === PerformanceMonitoringControlPanelKey,
			image: this.props.selectedControlPanelType === PerformanceMonitoringControlPanelKey ? stethoscopeActiveIcon : stethoscopeIcon,
			name: "Performance Monitoring"
		}

		let multiTenantListProps = {
			id: "multiTenantListControlPanelNavLink",
			link: "/controlPanel/MultiTenantList",
			selected: this.props.selectedControlPanelType === MultiTenantListControlPanelKey,
			image: this.props.selectedControlPanelType === MultiTenantListControlPanelKey ? buildingActiveIcon : buildingIcon,
			name: "Multi-Tenant List"
		}

		let LandNotificationOneAlertsProps = {
			id: "LandNotificationOneAlertsControlPanelNavLink",
			link: "/controlPanel/LandNotificationOneAlerts",
			selected: this.props.selectedControlPanelType === LandNotificationOneAlertsControlPanelKey,
			image: this.props.selectedControlPanelType === LandNotificationOneAlertsControlPanelKey ? arrowRightActiveIcon : arrowRightIcon,
			name: "LNS1 Alerts"
		}

		let HelloWorldProps = {
			id: "HelloWorldControlPanelNavLink",
			link: "/controlPanel/HelloWorld",
			selected: this.props.selectedControlPanelType === HelloWorldControlPanelKey,
			image: this.props.selectedControlPanelType === HelloWorldControlPanelKey ? smileActiveIcon : smileIcon,
			name: "Hello World"
		}

		let alertAdminProps = {
			image: bellIconBlack,
			name: "Alert Admin:"
		}

		let alertSettingsProps = {
			id: "alertSettingControlPanelNavLink",
			link: "/controlPanel/alertSettings",
			selected: this.props.selectedControlPanelType === AlertSettingsControlPanelKey,
			image: this.props.selectedControlPanelType === AlertSettingsControlPanelKey ? cogActiveIcon : cogIcon,
			name: "Settings"
		}

		let alertListProps = {
			id: "alertListControlPanelNavLink",
			link: "/controlPanel/Alerts",
			selected: this.props.selectedControlPanelType === AlertListControlPanelKey,
			image: this.props.selectedControlPanelType === AlertListControlPanelKey ? bellActiveIcon : bellIcon,
			name: "Alert List"
		}

		let emailListProps = {
			id: "emailListControlPanelNavLink",
			link: "/controlPanel/Emails",
			selected: this.props.selectedControlPanelType === EmailListControlPanelKey,
			image: this.props.selectedControlPanelType === EmailListControlPanelKey ? envelopeActiveIcon : envelopeIcon,
			name: "Email List"
		}

		let phoneListProps = {
			id: "phoneListControlPanelNavLink",
			link: "/controlPanel/Phones",
			selected: this.props.selectedControlPanelType === PhoneListControlPanelKey,
			image: this.props.selectedControlPanelType === PhoneListControlPanelKey ? mobileActiveIcon : mobileIcon,
			name: "Phone List"
		}

		let userAdminProps = {
			image: userIconBlack,
			name: "User Admin:"
		}

		let userAccessProps = {
			id: "userAccessControlPanelNavLink",
			link: "/controlPanel/UserAccess",
			selected: this.props.selectedControlPanelType === UserAccessControlPanelKey,
			image: this.props.selectedControlPanelType === UserAccessControlPanelKey ? doorOpenActiveIcon : doorOpenIcon,
			name: "Access"
		}

		let userLockoutProps = {
			id: "userLockoutControlPanelNavLink",
			link: "/controlPanel/UserLockout",
			selected: this.props.selectedControlPanelType === UserLockoutControlPanelKey,
			image: this.props.selectedControlPanelType === UserLockoutControlPanelKey ? userLockActiveIcon : userLockIcon,
			name: "Lockout 1"
		}

		let userLockout2Props = {
			id: "userLockout2ControlPanelNavLink",
			link: "/controlPanel/UserLockout2",
			selected: this.props.selectedControlPanelType === UserLockout2ControlPanelKey,
			image: this.props.selectedControlPanelType === UserLockout2ControlPanelKey ? userLockActiveIcon : userLockIcon,
			name: "Lockout 2"
		}

		let userPurgeNowProps = {
			id: "userPurgeNowControlPanelNavLink",
			link: "/controlPanel/UserPurgeNow",
			selected: this.props.selectedControlPanelType === UserPurgeNowControlPanelKey,
			image: this.props.selectedControlPanelType === UserPurgeNowControlPanelKey ? userPurgeActiveIcon : userPurgeIcon,
			name: "Purge Now"
		}

		let userPurgeScheduleProps = {
			id: "userPurgeNowControlPanelNavLink",
			link: "/controlPanel/UserPurgeSchedule",
			selected: this.props.selectedControlPanelType === UserPurgeScheduleControlPanelKey,
			image: this.props.selectedControlPanelType === UserPurgeScheduleControlPanelKey ? userClockActiveIcon : userClockIcon,
			name: "Purge Schedule"
		}

		let userListProps = {
			id: "userListControlPanelNavLink",
			link: "/controlPanel/Users",
			selected: this.props.selectedControlPanelType === UserListControlPanelKey,
			image: this.props.selectedControlPanelType === UserListControlPanelKey ? usersActiveIcon : usersIcon,
			name: "User Manager"
		}

		let auditLogAdminProps = {
			image: fileIcon,
			name: "Audit Log Admin:"
		}

		let auditLogPurgeScheduleProps = {
			id: "auditLogPurgeScheduleControlPanelNavLink",
			link: "/controlPanel/AuditLogPurgeSchedule",
			selected: this.props.selectedControlPanelType === AuditLogPurgeScheduleControlPanelKey,
			image: this.props.selectedControlPanelType === AuditLogPurgeScheduleControlPanelKey ? auditLogPurgeActiveIcon : auditLogPurgeIcon,
			name: "Audit Log Purge"
		}

		let auditLogReportProps = {
			id: "auditLogReportControlPanelNavLink",
			link: "/controlPanel/AuditLogReport",
			selected: this.props.selectedControlPanelType === AuditLogReportControlPanelKey,
			image: this.props.selectedControlPanelType === AuditLogReportControlPanelKey ? fileActiveIcon : fileIcon,
			name: "Report"
		}

		let defaultRoute = <Route path="/controlPanel" component={HomeSelections} />;

		if (AlertListControlPanelKey === this.props.selectedControlPanelType) {
			defaultRoute = <Route path="/controlPanel" component={AlertList} />;
		} else if (EmailListControlPanelKey === this.props.selectedControlPanelType) {
			defaultRoute = <Route path="/controlPanel" component={EmailList} />;
		} else if (PhoneListControlPanelKey === this.props.selectedControlPanelType) {
			defaultRoute = <Route path="/controlPanel" component={PhoneList} />;
		} else if (AlertSettingsControlPanelKey === this.props.selectedControlPanelType) {
			defaultRoute = <Route path="/controlPanel" component={AlertSettings} />;
		} else if (AuditLogPurgeScheduleControlPanelKey === this.props.selectedControlPanelType) {
			defaultRoute = <Route path="/controlPanel" component={AuditLogPurgeSchedule} />;
		} else if (AuditLogReportControlPanelKey === this.props.selectedControlPanelType) {
			defaultRoute = <Route path="/controlPanel" component={UserReport} />;
		} else if (UserAccessControlPanelKey === this.props.selectedControlPanelType) {
			defaultRoute = <Route path="/controlPanel" component={UserAccess} />;
		} else if (UserPurgeNowControlPanelKey === this.props.selectedControlPanelType) {
			defaultRoute = <Route path="/controlPanel" component={UserPurgeNow} />;
		} else if (UserPurgeScheduleControlPanelKey === this.props.selectedControlPanelType) {
			defaultRoute = <Route path="/controlPanel" component={UserPurgeSchedule} />;
		} else if (UserListControlPanelKey === this.props.selectedControlPanelType) {
			defaultRoute = <Route path="/controlPanel" component={UserList} />;
		} else if (CommonControlPanelKey === this.props.selectedControlPanelType) {
			defaultRoute = <Route path="/controlPanel" component={Common} />;
		} else if (LanguagesControlPanelKey === this.props.selectedControlPanelType) {
			defaultRoute = <Route path="/controlPanel" component={Languages} />;
		} else if (LoginPageLinksControlPanelKey === this.props.selectedControlPanelType) {
			defaultRoute = <Route path="/controlPanel" component={LoginPageLinks} />;
		} else if (LoginPageLatestNewsControlPanelKey === this.props.selectedControlPanelType) {
			defaultRoute = <Route path="/controlPanel" component={LoginPageLatestNews} />;
		} else if (LoginPageSlidesControlPanelKey === this.props.selectedControlPanelType) {
			defaultRoute = <Route path="/controlPanel" component={LoginPageSlides} />;
		} else if (LoginPageRegistrationControlPanelKey === this.props.selectedControlPanelType) {
			defaultRoute = <Route path="/controlPanel" component={LoginPageRegistration} />;
		} else if (HomeLatestNewsControlPanelKey === this.props.selectedControlPanelType) {
			defaultRoute = <Route path="/controlPanel" component={HomeLatestNews} />;
		} else if (HomeExternalLinksControlPanelKey === this.props.selectedControlPanelType) {
			defaultRoute = <Route path="/controlPanel" component={HomeExternalLinks} />;
		} else if (HomeSelectionsControlPanelKey === this.props.selectedControlPanelType) {
			defaultRoute = <Route path="/controlPanel" component={HomeSelections} />;
		} else if (UserLockoutControlPanelKey === this.props.selectedControlPanelType) {
			defaultRoute = <Route path="/controlPanel" component={UserLockout} />;
		} else if (UserLockout2ControlPanelKey === this.props.selectedControlPanelType) {
			defaultRoute = <Route path="/controlPanel" component={UserLockout2} />;
		} else if (PerformanceMonitoringControlPanelKey === this.props.selectedControlPanelType) {
			defaultRoute = <Route path="/controlPanel" component={PerformanceMonitoring} />;
		} else if (MultiTenantListControlPanelKey === this.props.selectedControlPanelType) {
			defaultRoute = <Route path="/controlPanel" component={MultiTenantList} />;
		} 

		let technicalNavLink = '';
		if (this.props.role === 'FOREVER' || this.props.role === 'TRIMIN') {
			technicalNavLink = <><Nav.Link eventKey="disabled" disabled style={{ fontWeight: 'bold', background: "gray", color: "black"}} className='side-nav-header' ><SideNavigationLabel {...technicalProps} /></Nav.Link>
			<SideNavigationNavLink {...HelloWorldProps} />
			<SideNavigationNavLink {...LandNotificationOneAlertsProps} />
			<SideNavigationNavLink {...languagesProps} />
			<SideNavigationNavLink {...multiTenantListProps} /> 
			<SideNavigationNavLink {...performanceMonitoringProps} /> 
			</>
		}

		return (
			<div>
				<CommonTop history={this.props.history} />
				<div style={{ float: "left", minWidth: 38, maxWidth: 280 }}>
					<SideNavigationToggle />
					<Navbar bg="light" style={{ padding: 0, display: "block" }}>
						<Navbar.Toggle aria-controls="basic-navbar-nav" />
						<Nav className="flex-column" style={{ width: '100%', float: "left", marginLeft: 2 }}>		
							<Nav.Link eventKey="disabled" disabled style={{ fontWeight: 'bold', background: "gray", color: "black"}} className='side-nav-header' ><SideNavigationLabel {...alertAdminProps} /></Nav.Link>
								<SideNavigationNavLink {...alertListProps} />	
								<SideNavigationNavLink {...emailListProps} />
								<SideNavigationNavLink {...phoneListProps} />		
								<SideNavigationNavLink {...alertSettingsProps} />
							<Nav.Link eventKey="disabled" disabled style={{ fontWeight: 'bold', background: "gray", color: "black"}} className='side-nav-header' ><SideNavigationLabel {...auditLogAdminProps} /></Nav.Link>
								<SideNavigationNavLink {...auditLogPurgeScheduleProps} />
								<SideNavigationNavLink {...auditLogReportProps} />
							<Nav.Link eventKey="disabled" disabled style={{ fontWeight: 'bold', background: "gray", color: "black"}} className='side-nav-header' ><SideNavigationLabel {...userAdminProps} /></Nav.Link>
								<SideNavigationNavLink {...userAccessProps} />
								<SideNavigationNavLink {...userLockoutProps} />
								<SideNavigationNavLink {...userLockout2Props} />
								<SideNavigationNavLink {...userPurgeNowProps} />	
								<SideNavigationNavLink {...userPurgeScheduleProps} />	
								<SideNavigationNavLink {...userListProps} />	
							<Nav.Link eventKey="disabled" disabled style={{ fontWeight: 'bold', background: "gray", color: "black"}} className='side-nav-header' ><SideNavigationLabel {...webPagesProps} /></Nav.Link>
								<SideNavigationNavLink {...commonProps} />
								<SideNavigationNavLink {...loginPageLinksProps} />
								<SideNavigationNavLink {...loginPageLatestNewsProps} />
								<SideNavigationNavLink {...loginPageRegistrationProps} />
								<SideNavigationNavLink {...loginPageSlidesProps} />
								<SideNavigationNavLink {...homeMoreLinksProps} />
								<SideNavigationNavLink {...homeLatestNewsProps} />
								<SideNavigationNavLink {...homeSelectionsProps} />
							{technicalNavLink}							
						</Nav>
					</Navbar>
				</div>
				<div style={{paddingBottom: 4}}>
					<Switch>
						<Route path="/controlPanel/common" component={Common} />
						<Route path="/controlPanel/homeLatestNews" component={HomeLatestNews} />
						<Route path="/controlPanel/homeExternalLinks" component={HomeExternalLinks} />
						<Route path="/controlPanel/homeSelections" component={HomeSelections} />
						<Route path="/controlPanel/languages" component={Languages} />
						<Route path="/controlPanel/loginPageLinks" component={LoginPageLinks} />
						<Route path="/controlPanel/loginPageLatestNews" component={LoginPageLatestNews} />
						<Route path="/controlPanel/loginPageSlides" component={LoginPageSlides} />
						<Route path="/controlPanel/loginPageRegistration" component={LoginPageRegistration} />
						<Route path="/controlPanel/performanceMonitoring" component={PerformanceMonitoring} />
						<Route path="/controlPanel/multiTenantList" component={MultiTenantList} />
						<Route path="/controlPanel/LandNotificationOneAlerts" component={LandNotificationOneAlerts} />
						<Route path="/controlPanel/HelloWorld" component={HelloWorld} />
						<Route path="/controlPanel/userAccess" component={UserAccess} />
						<Route path="/controlPanel/userLockout2" component={UserLockout2} />
						<Route path="/controlPanel/userLockout" component={UserLockout} />
						<Route path="/controlPanel/userPurgeNow" component={UserPurgeNow} />
						<Route path="/controlPanel/userPurgeSchedule" component={UserPurgeSchedule} />
						<Route path="/controlPanel/userPassword/:id" component={UserPassword} />
						<Route path="/controlPanel/users/:id" component={UserEntry} />
						<Route path="/controlPanel/users" component={UserList} />
						<Route path="/controlPanel/alertSettings" component={AlertSettings} />
						<Route path="/controlPanel/alertsView/:id" component={AlertView} />
						<Route path="/controlPanel/alerts/:id" component={AlertEntry} />
						<Route path="/controlPanel/alerts" component={AlertList} />
						<Route path="/controlPanel/emails" component={EmailList} />
						<Route path="/controlPanel/phones" component={PhoneList} />
					
						<Route path="/controlPanel/auditLogPurgeSchedule" component={AuditLogPurgeSchedule} />
						<Route path="/controlPanel/auditLogReport" component={UserReport} />
						{defaultRoute}
					</Switch>
				</div>
			</div>	
		);
	}
}

export default connect(mapStateToProps)(ControlPanel);